import { errorLoggerWithoutPromise } from 'axios-logger/lib/logger/error';
import { requestLogger, responseLogger } from 'axios-logger';
import { authHandler } from './auth-handler';
import { requestErrorHandler, responseErrorHandler } from './error-handler';
import store from '@/store';
import { modulesName } from '@/store';
import { LOGGER } from '@/config';

export const requestInterceptor = {
  onFulfilled: async (config) => {
    const skipLoading = config?.headers?.skipLoading;
    if (!skipLoading) {
      // start loading
      store.dispatch(`${modulesName.appModuleName}/setLoading`, true);
    }
    await authHandler(config);

    return LOGGER.AXIOS ? requestLogger(config) : config;
  },

  onRejected: (error) => {
    // stop loading
    store.dispatch(`${modulesName.appModuleName}/setLoading`, false);
    requestErrorHandler(error);

    return LOGGER.AXIOS ? errorLoggerWithoutPromise(error) : error;
  },
};

export const responseInterceptor = {
  onFulfilled(response) {
    // stop loading
    store.dispatch(`${modulesName.appModuleName}/setLoading`, false);
    return LOGGER.AXIOS ? responseLogger(response) : response;
  },

  onRejected(error) {
    // stop loading
    store.dispatch(`${modulesName.appModuleName}/setLoading`, false);
    responseErrorHandler(error);

    return LOGGER.AXIOS ? errorLoggerWithoutPromise(error) : error;
  },
};
